import React from "react";
import styled from "styled-components";
import classes from "./navbar.module.css";
import { Search, ShoppingCartOutlined, Menu } from "@material-ui/icons";
import { Badge } from "@material-ui/core";
const Container = styled.div`
  height: 60px;
`;

const Wrapper = styled.div`
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Language = styled.span`
  font-size: 14px;
  cursor: pointer;
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;
const SearchContainer = styled.div`
  display: flex;
  border: 0.5px solid lightgray;
  align-items: center;
  margin-left: 25px;
  border-radius: 25px;
  padding: 5px;
`;

const Input = styled.input`
  border: none;
  outline: none;
`;

const Center = styled.div`
  flex: 1;
  text-align: center;
`;

const Logo = styled.h1`
  font-weight: bold;

`;

const Right = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const MenuItem = styled.div`
  font-size: 14px;
  cursor: pointer;
  margin-left: 25px;
`;

const Navbar = () => {
  return (
    <Container>
      <Wrapper>
        <Left>
          <Language className={classes.hideOnSmall}>EN</Language>
          <Menu className={classes.hideOnLg} />
          <SearchContainer className={classes.hideOnSmall}>
            <Input className={classes.hideOnSmall} placeholder="Search" />
            <Search className={classes.searchIcon} />
          </SearchContainer>
          
        </Left>
        <Center>
          <Logo>Reesho.</Logo>
        </Center>
        <Right>
          <MenuItem className={classes.hideOnSmall}>Register</MenuItem>
          <MenuItem className={classes.hideOnSmall}>Sign in</MenuItem>
          <MenuItem>
            <Badge badgeContent={4} color="primary">
              <ShoppingCartOutlined />
            </Badge>
          </MenuItem>
        </Right>
      </Wrapper>
    </Container>
  );
};

export default Navbar;
